import React from 'react';
import { Button, Grid , Table} from 'semantic-ui-react';
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import Form01 from './Form01';
import FormFiltro02 from './FormFiltro02';
import FormFiltro03 from './FormFiltro03'; 
import FormAprobado from './FormAprobado';
import FormRechazado from './FormRechazado';

import { estados } from './Estados.js'; 

registerLocale('es', es)

/**
 * https://medium.com/@l_e/writing-a-wizard-in-react-8dafbce6db07
 * https://github.com/geetotes/acme-insurance-quotes
 * https://geetotes.github.io/acme-insurance-quotes/
 * 
 * datetime picker (no es parte de semantic)
 * https://github.com/Hacker0x01/react-datepicker
 * https://reactdatepicker.com
 * https://www.freakyjolly.com/react-datepicker-using-react-datepicker/
 * 
 */

export const Inicio = (props) => {

  return(
    <Grid>

      <Grid.Row>
        
        <p>Bienvenido al asistente de validación de Expedientes</p>

        <p>
          Este asistente pretende ayudarlo a obtener una propuesta de 
          ponencia para un expediente de Hábeas Data en el Tribunal Constitucional.
        </p>

        <Table definition>
          <Table.Body>
            <Table.Row key='01'>
              <Table.Cell width={5}>Número de Expediente:</Table.Cell>
              <Table.Cell> {props.caso.cnumExpediente}</Table.Cell>
            </Table.Row>
            <Table.Row key='02'>
              <Table.Cell width={5}>Distrito Judicial:</Table.Cell>
              <Table.Cell> {props.caso.ctxtProcedencia}</Table.Cell>
            </Table.Row>
            <Table.Row key='03'>
              <Table.Cell width={5}>Fallo Primera instancia:</Table.Cell>
              <Table.Cell> {props.caso.ctxtFallo1}</Table.Cell>
            </Table.Row>
            <Table.Row key='04'>
              <Table.Cell width={5}>Fallo segunda instancia:</Table.Cell>
              <Table.Cell> {props.caso.ctxtFallo2}</Table.Cell>
            </Table.Row>

          </Table.Body>
        </Table> 

      </Grid.Row>
      <Grid.Row>
        <Grid.Column floated='left' width={5}> </Grid.Column>
        <Grid.Column floated='right' width={5}>
          <Button primary onClick={() => props.next(estados.FASE_1)}>Iniciar</Button>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );

}

export const Form1 = (props) => {
  return(
    <Form01 
      next={props.next}
      back={props.back}
      saveForm={props.saveForm}
      caso={props.caso} />
  );
}

export const Filtro2 = (props) => {
  return(
    <FormFiltro02 
      next={props.next}
      back={props.back}
      saveForm={props.saveForm} 
      caso={props.caso}/>
  );
}

export const Filtro3 = (props) => {
  return(
    <FormFiltro03 
      next={props.next}
      back={props.back}
      saveForm={props.saveForm} 
      caso={props.caso}/>
  );
}

export const Aceptado = (props) => {
  return(
    <FormAprobado
      next={props.next}
      back={props.back}
      saveForm={props.saveForm}
      caso={props.caso} />
  );
}

export const Rechazado = (props) => {
  return(
    <FormRechazado
      next={props.next}
      back={props.back}
      saveForm={props.saveForm}
      caso={props.caso} />
  );
}